// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__dOb13","label":"Breadcrumb_label__4FLre"};